import _ from 'lodash';
import React, {FunctionComponent, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router-dom';
import {Grid} from '@material-ui/core';
import LoadProgressBar from '@treez-ui/core/feedback/loading/LoadingBar';
import {Title, TitleSize} from '@treez-ui/core/layout/Title';
import {OrganizationState} from '~/redux/reducers/OrganizationReducer';
import {selectOrganizationState} from '~/redux/selectors/organizationSelectors';
import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import StorePreviewInList from '~/modules/pages/stores/StorePreviewInList';
import UIWrapper from '~/modules/pages/UIWrapper';
import {StoreAttributes} from '~/lib/directory';
import {useQuery} from '@tanstack/react-query';
import {
    OrganizationWithCatalogsAttributesAndPriceTiers,
    searchForOrganization,
} from '../../../lib/entity';
import {recieveOrganizationInformation} from '../../../redux/actions/OrganizationActions';
import {closeFeedbackModal, openFeedbackModal} from '../../../redux/actions/UserFeedbackActions';
import {ModalType} from '@treez-ui/core/feedback/modals';

interface StoresParameters {
    organizationId: number;
}

const Stores: FunctionComponent<RouteComponentProps> = (props: RouteComponentProps) => {
    const {
        match: {params},
    } = props;

    const {organizationId} = params as StoresParameters;

    const {stores, isFetching} = useSelector<GlobalApplicationState, OrganizationState>(
        selectOrganizationState
    );

    const dispatch = useDispatch();
    const queryKey = ['search-for-organization', organizationId];
    const organizationQuery = useQuery(queryKey, () =>
        searchForOrganization(organizationId, dispatch)
    );

    useEffect(() => {
        if (organizationQuery.isError) {
            openFeedbackModal(closeFeedbackModal, 'Error Retrieving Organization', {
                bodyText: `There was an error retrieving organization details:
                                        ${organizationQuery.error}`,
                type: ModalType.ERROR,
            });
        } else if (organizationQuery.isFetched) {
            dispatch(
                recieveOrganizationInformation(
                    organizationQuery.data as OrganizationWithCatalogsAttributesAndPriceTiers
                )
            );
        }
    }, [
        organizationQuery.data,
        organizationQuery.isFetched,
        organizationQuery.isError,
        organizationQuery.error,
        dispatch,
    ]);

    return (
        <UIWrapper>
            <Title size={TitleSize.LARGE} text="Stores" styles={{marginTop: '10px'}} />
            {isFetching && <LoadProgressBar />}
            {isFetching === false && _.isEmpty(stores) === false && (
                <Grid className="stores-page" container spacing={4}>
                    {_.map(stores, (store: StoreAttributes, idx) => {
                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={store.name}>
                                <StorePreviewInList key={store.name} store={store} />
                            </Grid>
                        );
                    })}
                </Grid>
            )}
            {isFetching === false && _.isEmpty(stores) && (
                <Title text="No stores have been created" />
            )}
        </UIWrapper>
    );
};

export default Stores;
